import React from "react";
import Icon from "./Icon";

export const CheckGreenIcon = () => (
  <Icon>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00001 16.17L5.53001 12.7C5.14001 12.31 4.51001 12.31 4.12001 12.7C3.73001 13.09 3.73001 13.72 4.12001 14.11L8.30001 18.29C8.69001 18.68 9.32001 18.68 9.71001 18.29L20.29 7.71001C20.68 7.32001 20.68 6.69001 20.29 6.30001C19.9 5.91001 19.27 5.91001 18.88 6.30001L9.00001 16.17Z" fill="#39842B"/>
  </Icon>
);
